import Axios from 'axios'
import msk from 'msk'

export const currencyFormat = (value: number) => {
  if (value) {
    let stringValue = value.toString()
    while (stringValue.charAt(0) === '0') {
      stringValue = stringValue.substr(1)
    }
    // if (stringValue.indexOf('.') === -1) {
    //   stringValue = stringValue.concat('.00')
    // }
    return stringValue.replace(/\D+/g, '').replace(/(\d+)(\d{2})$/, '$1.$2').replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ')
  }
}

export const passwordValidation = (value: string) => {
  const strongRegex = new RegExp('^(?=.*[a-z]){3,}(?=.*[A-Z]){2,}(?=.*[0-9]){2,}(?=.*[!@#$%^&*()--__+./]){1,}.{8,}$')
  return strongRegex.test(value)
}

export const emailRequiredValidation = {
  format: (value: any) => {
    return value
  },
  parse: (value: any) => {
    return value
  },
  validate: async (value: string, values: any, meta: any) => {
    if (value) {
      try {
        await Axios({
          method: 'GET',
          url: `${process.env.REACT_APP_API_URL}/email/bounce/${value}`,
        })
        return null
      } catch (error) {
        return 'Email inválido'
      }
    } else {
      return 'O campo é obrigatório'
    }
  },

}

export const currentYearValidation = {
  format: (value: any) => {
    return value
  },
  parse: (value: any) => {
    if (value) {
      let stringValue = value.toString()
      if (stringValue.length > 4) {
        stringValue = stringValue.slice(0, -1)
        return parseInt(stringValue)
      }
    }
    return value
  },
  validate: async (value: string, values: any, meta: any) => {
    if (value) {
      const min = 1960
      const max = new Date().getFullYear()
      const intValue = parseInt(value)
      if (intValue < min) {
        return 'O ano mínimo é ' + min
      }

      if (intValue > max) {
        return 'O ano máximo é ' + max
      }

    }
  },
}

export const termsRequiredValidation = {
  format: (value: any) => {
    return value
  },
  parse: (value: any) => {
    return value
  },
  validate: (value: string, values: any, meta: any) => {
    if (!value) {
      return 'Esta ação é obrigatória'
    }
  },
}

export const cpfCnpjRequiredValidation = {
  format: (value: any) => {
    // const cpf = '999.999.999-99'
    // if (value.length <= cpf.length) {
    return msk.fit(value, '999.999.999-99');
    // } else {
    //   return msk.fit(value, '99.999.999/9999-99');
    // }


  },
  parse: (value: any) => {
    return value
  },
  validate: (value: string, values: any, meta: any) => {

    if (!value) {
      return 'Campo obrigatório'
    }
    const cleanValue = cleanCpfCnpj(value)
    if (cleanValue.length !== 14 && cleanValue.length !== 11) {
      return 'CPF inválido'
    }
  },
}

export const phone = {
  format: (value: string) => {
    if (!value)
      return value
    return value.length === 11 ? msk.fit(value, '(99) 99999-9999') : msk.fit(value, '(99) 9999-9999')


  },
  parse: (value: any) => {
    return value
  },
  validate: (value: string, values: any, meta: any) => {
  },
}

export const cpfCnpjValidation = {
  format: (value: any) => {
    // const cpf = '999.999.999-99'
    // if (value.length <= cpf.length) {
    return msk.fit(value, '999.999.999-99');
    // } else {
    //   return msk.fit(value, '99.999.999/9999-99');
    // }


  },
  parse: (value: any) => {
    return value
  },
  validate: (value: string, values: any, meta: any) => {

    // if (!value) {
    //   return 'Campo obrigatório'
    // }
    const cleanValue = cleanCpfCnpj(value)
    if (value && cleanValue.length !== 14 && cleanValue.length !== 11) {
      return 'CPF inválido'
    }
  },
}


export const cleanCpfCnpj = (value: string) => {
  return value.split('.').join('').split('-').join('').split('/').join('')
}
